import type { Driver } from '../types';

export function sameVehicleId(a: number | null | undefined, b: number | null | undefined): boolean {
  if (a == null && b == null) return true;
  if (a == null || b == null) return false;
  return Number(a) === Number(b);
}

export function isVehicleIdEmpty(v: number | null | undefined): boolean {
  return v == null || !Number.isFinite(Number(v));
}

/** Автоподстановка тягача/прицепа при смене водителя (если поле не меняли вручную относительно предыдущего водителя). */
export function computeNextVehiclesFromDriverChange(
  prevDriver: Driver | null,
  newDriver: Driver | null | undefined,
  currentTruckId: number | null | undefined,
  currentTrailerId: number | null | undefined
): { vehicleId: number | undefined; trailerVehicleId: number | undefined } {
  if (!newDriver) {
    return { vehicleId: undefined, trailerVehicleId: undefined };
  }

  const prevTruckDef = prevDriver?.defaultVehicleId;
  const prevTrailerDef = prevDriver?.defaultTrailerVehicleId;

  const truckEmpty = isVehicleIdEmpty(currentTruckId);
  const truckMatchesPrevDefault = prevTruckDef != null && sameVehicleId(currentTruckId, prevTruckDef);

  let nextVehicleId: number | undefined;
  if (truckEmpty || truckMatchesPrevDefault) {
    const nv = newDriver.defaultVehicleId;
    nextVehicleId = nv != null && Number.isFinite(Number(nv)) ? Number(nv) : undefined;
  } else {
    const v = currentTruckId;
    nextVehicleId = v != null && Number.isFinite(Number(v)) ? Number(v) : undefined;
  }

  const trailerEmpty = isVehicleIdEmpty(currentTrailerId);
  const trailerMatchesPrevDefault = prevTrailerDef != null && sameVehicleId(currentTrailerId, prevTrailerDef);

  let nextTrailerId: number | undefined;
  if (trailerEmpty || trailerMatchesPrevDefault) {
    const nt = newDriver.defaultTrailerVehicleId;
    nextTrailerId = nt != null && Number.isFinite(Number(nt)) ? Number(nt) : undefined;
  } else {
    const t = currentTrailerId;
    nextTrailerId = t != null && Number.isFinite(Number(t)) ? Number(t) : undefined;
  }

  return { vehicleId: nextVehicleId, trailerVehicleId: nextTrailerId };
}
